export default class Analytics {
    static initPlausibleAnalytics() {
        if (window.plausible) {
            if (typeof window.pageVerticalCategory !== "undefined") {
                window.plausible("pageview", {
                    props: { vertical_category: window.pageVerticalCategory },
                });
            } else {
                window.plausible("pageview");
            }
        } else {
            console.error("Plausible tracking is not initialized.");
        }
    }
}
